<template>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
        <section :class="this.name">
            <div id="class-bg" class="player"></div>
            <div class="bg"></div>
            <div class="content">
                <div class="cont">
                    <h2>진마카엘 클래스</h2>
                    <h3>둠브링거</h3>
                    <p>강한 공격력과 돌진 기술을 가진 최강의 전사 </p>
                    <p>주요무기 고대검</p>
                </div>
                <div class="cont">
                    <h2>진마카엘 클래스</h2>
                    <h3>소울하운드</h3>
                    <p>세검술에 특화된 궁극의 마검사 </p>
                    <p>주요무기 세검</p>
                </div>
                <div class="cont">
                    <h2>진마카엘 클래스</h2>
                    <h3>트릭스터</h3>
                    <p>공격할수록 강해지는 화살을 발사하는 탁월한 궁수</p>
                    <p>주요무기 활</p>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    import BasePage from "./mixins/basePage.js";
    import {rePostionContents, reSizeBackground} from '@/utils/cavasResize';
    import canvasObjPosition from '@/utils/canvasObjPosition';

    export default {
        name: "class",
        mixins: [BasePage],
        data() {
            return {
                name: "class",
                contentData: [
                    {type: "bg", source: this.$staticUrl + "img/bg_5.jpg", objName: "bg"},
                    {type: 'bgChrCon'},
                ],
                mouseX:0,
                isMouseMove:false,
                conBoxColor:[0x110303,0x000a30,0x00302f],
                conObjPos:[
                    {imgX:140, imgY:280, wtxtX:-0, wtxtY:612,  weaponX:-115, weaponY:297},
                    {imgX:3, imgY:327, wtxtX:50, wtxtY:522,  weaponX:-63, weaponY:290},
                    {imgX:303, imgY:292, wtxtX:-47, wtxtY:522,  weaponX:-160, weaponY:253}
                    ],
                overNum:3,
                conObjMotion:[]
            };
        },
        methods: {
            canvasSet() {
                this.bgPlayer = new nc.promokit.Player({
                    selector: '#class-bg',
                    videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/bg_5.mp4',
                    mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:true
                });
                this.bgPlayer.pause();
                TweenMax.set(this.$el.querySelector('#class-bg'), {autoAlpha:0});

                this.baseCavasSet(this.contentData);

                let boxW = this.documentSetSize.width/3;
                let boxH = this.documentSetSize.height;
                let thisV = this;
                for(let i = 0; i<3; i++){
                    this.cvObj['conBox'+i] = new PIXI.Container();
                    this.cvObj['conBox'+i].x = boxW * i;
                    this.cvObj['conBox'+i].width = boxW - 2;
                    this.cvObj['conBox'+i].height = boxH;

                    this.cvObj.bgChrCon.addChild(this.cvObj['conBox'+i]);

                    this.cvObj['conBg'+i] = new PIXI.Sprite(PIXI.Texture.WHITE);
                    this.cvObj['conBg'+i].width = boxW-2;
                    this.cvObj['conBg'+i].height = boxH;
                    this.cvObj['conBg'+i].tint = this.conBoxColor[i];
                    this.cvObj['conBg'+i].alpha = 0.22;
                    this.cvObj['conBox'+i].addChild(this.cvObj['conBg'+i]);

                    this.cvObj['conBg'+i].interactive = true;
                   // this.cvObj['conBg'+i].cursor = 'pointer';
                    this.cvObj['conBg'+i].key = 'conBox'+i;
                    this.cvObj['conBg'+i].pointerover = function(e){
                        thisV.conOverMotion(this.key)
                    };


                    this.cvObj['conObj'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/obj_5_${i+1}.png`);
                    canvasObjPosition(this.cvObj['conObj'+i], this.cvObj['conBox'+i], boxW/2+this.conObjPos[i].imgX, this.conObjPos[i].imgY);
                    //this.cvObj['conObj'+i].alpha = 0;

                    this.cvObj['conCover'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/obj_5_cover.png`);
                    this.cvObj['conCover'+i].width = boxW-2;
                    this.cvObj['conCover'+i].height = boxH;
                    this.cvObj['conCover'+i].alpha = 0;
                    this.cvObj['conBox'+i].addChild(this.cvObj['conCover'+i]);

                    this.cvObj['conWeapon'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/obj_5_${i+1}_w.png`);
                    canvasObjPosition(this.cvObj['conWeapon'+i], this.cvObj['conBox'+i], boxW/2+this.conObjPos[i].weaponX, this.conObjPos[i].weaponY);
                   // this.cvObj['conWeapon'+i].alpha = 0;

                    this.cvObj['conWtxt'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_5_${i+1}_wtxt.png`);
                    canvasObjPosition(this.cvObj['conWtxt'+i], this.cvObj['conBox'+i], boxW/2+this.conObjPos[i].wtxtX, this.conObjPos[i].wtxtY);
                    //this.cvObj['conWtxt'+i].alpha = 0;

                    this.cvObj['conTxtBox'+i] = new PIXI.Container();
                    this.cvObj['conBox'+i].addChild(this.cvObj['conTxtBox'+i]);

                    this.cvObj['conIcon'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_5_${i+1}_icon.png`);
                    canvasObjPosition(this.cvObj['conIcon'+i], this.cvObj['conTxtBox'+i], boxW/2, 465);
                    this.cvObj['conTit'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_5_${i+1}_tit.png`);
                    canvasObjPosition(this.cvObj['conTit'+i], this.cvObj['conTxtBox'+i], boxW/2, 652);
                    this.cvObj['conTxt'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_5_${i+1}_txt.png`);
                    canvasObjPosition(this.cvObj['conTxt'+i], this.cvObj['conTxtBox'+i], boxW/2, 700);
                }
                this.canvas.stage.interactive = true;
                this.canvas.stage.pointerout = function(e){
                    thisV.conOverMotion('conBox3')
                };
                this.cvObj.txtTitleCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtTitleCon);
                this.cvObj.txtTitle = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_5_tit.png');
                canvasObjPosition(this.cvObj.txtTitle, this.cvObj.txtTitleCon, this.contentSize.w/2, 195);

                this.canvas.ticker.add(()=> {
                    if(!this.isMouseMove)return;
                    let centerNum = this.documentSetSize.width/2;
                    let targetX = (centerNum - this.mouseX);
                });
            },
            conOverMotion(key){
                if(!this.isMouseMove)return;
                let num = key.slice(6);
                let boxW = this.documentSetSize.width/4;
                let boxX = 0;

                if(num == 3){
                    boxW = this.documentSetSize.width/3;
                }
                for(let i = 0; i<3; i++){
                    let tarW = boxW-2;
                    let tarY = 0;
                    let boxA = 1;
                    let coverA = 0;
                    if(i == num){
                        tarW = boxW*2-2;
                        tarY = 240;
                        boxA = 1;
                        coverA = 1;
                        this.conObjMotion[i].timeScale(1)
                        this.conObjMotion[i].play();
                    }else{
                        this.conObjMotion[i].timeScale(5)
                        this.conObjMotion[i].reverse();
                        boxA = 0.7;
                        coverA = 0;
                    }
                    if(i == 2)tarW +=2;
                    if(num == 3)boxA =1;

                    TweenMax.to(this.cvObj['conBox'+i], 0.5, {x:boxX})
                    TweenMax.to(this.cvObj['conBg'+i], 0.5, {width:tarW})
                    TweenMax.to(this.cvObj['conCover'+i], 0.5, {width:tarW, alpha:coverA})
                    TweenMax.to(this.cvObj['conIcon'+i], 0.5, {x:tarW/2})
                    TweenMax.to(this.cvObj['conTit'+i], 0.5, {x:tarW/2})
                    TweenMax.to(this.cvObj['conTxt'+i], 0.5, {x:tarW/2})
                    TweenMax.to(this.cvObj['conTxtBox'+i], 0.5, {y:tarY, pixi: { brightness: boxA,alpha:boxA}})


                    boxX += boxW;
                    if(i == num)boxX += boxW;

                    //this.cvObj['conBox'+i].height = this.documentSetSize.height;
                    this.cvObj['conBg'+i].height = this.documentSetSize.height;
                    this.cvObj['conCover'+i].height = this.documentSetSize.height;
                }

            },
            enter(el, done) {
                this.baseEnter();
                this.canvasSet();
                this.baseEnterMotion(el, done, this.contentData);

                this.enterMotion
                    .fromTo(this.cvObj.txtTitleCon, 2, {pixi: { brightness: 5}}, { pixi: { brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitle, 1, {pixi: { alpha: 0}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.conBg0, 1, {pixi: {alpha: 0}}, { pixi: {alpha: 0.22}, ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.conBg1, 1, {pixi: {alpha: 0}}, { pixi: { alpha: 0.22}, ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.conBg2, 1, {pixi: {alpha: 0}}, { pixi: { alpha: 0.22}, ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.conTxtBox0, 1, {pixi: {blur:10, y:30, brightness: 5, alpha: 0}}, { pixi: {blur:0, y:0, brightness: 1, alpha: 1}, ease:Sine.easeOut}, 'bgMotionEnd-=0')
                    .fromTo(this.cvObj.conTxtBox1, 1, {pixi: {blur:10, y:30, brightness: 5, alpha: 0}}, { pixi: {blur:0, y:0, brightness: 1, alpha: 1}, ease:Sine.easeOut}, 'bgMotionEnd-=0')
                    .fromTo(this.cvObj.conTxtBox2, 1, {pixi: {blur:10, y:30, brightness: 5, alpha: 0}}, { pixi: {blur:0, y:0, brightness: 1, alpha: 1}, ease:Sine.easeOut}, 'bgMotionEnd-=0')
                    .call(()=>{
                        this.isMouseMove = true;
                        this.conOverMotion('conBox1')
                    },null, null, 'bgMotionEnd+=1.5')
                    .call(()=>{
                        this.bgPlayer.seek(1);
                        this.bgPlayer.play();
                        TweenMax.set(this.$el.querySelector('#class-bg'), {autoAlpha:1})
                    }, null, null, 'bgMotionEnd+=0')
                    .to(this.cvObj.bg, 0.7, {pixi: { alpha: 0}, delay:0.2 }, 'bgMotionEnd+=0');

                //this.cvObj['conTxtBox'+i]

                this.enterMotion.play();

                for(let i = 0; i<3; i++){
                    let motion = new TimelineLite({paused:true});

                    motion
                        .fromTo(this.cvObj['conObj'+i], 1, {pixi: { brightness: 0,alpha:0, y:this.conObjPos[i].imgY+100}}, { pixi: { brightness: 1, alpha:1, y:this.conObjPos[i].imgY}, ease:Cubic.easeOut}, '+=0.4')
                        .fromTo(this.cvObj['conWeapon'+i], 1, {pixi: { brightness: 10,alpha:0, y:this.conObjPos[i].weaponY-50}}, {pixi: { brightness: 1,alpha:1, y:this.conObjPos[i].weaponY}, ease:Sine.easeOut}, '-=0.7')
                        .fromTo(this.cvObj['conWtxt'+i], 0.5, {pixi: { brightness: 0,alpha:0, y:this.conObjPos[i].wtxtY}}, {pixi: { brightness: 1,alpha:1, y:this.conObjPos[i].wtxtY}, ease:Cubic.easeOut}, '-=0.7')

                    this.conObjMotion.push(motion)
                }
            },
            leave(el, done) {
                if (this.enterMotion) this.enterMotion.pause();
                this.baseLeaveMotion(el, done);
            },
            resize(){
                this.documentSetSize.width =  document.querySelector('.container').clientWidth;
                this.documentSetSize.height = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
                rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);

                this.conOverMotion('conBox3')
                this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

            }
        }
    };
</script>

